import React from 'react';

function LockIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 22 30"
      enableBackground="new 0 0 22 30"
      className={className}
      stroke="#000000"
      fill="#000000"
    >
      <g>
        <line
          fill="#ffffff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          x1="11"
          y1="16.8"
          x2="11"
          y2="21.9"
        />
        <g>
          <path
            fill="none"
            strokeWidth="2"
            strokeMiterlimit="10"
            d="M11,1c4.1,0,7.5,3.4,7.9,8H3.1C3.6,4.5,6.9,1,11,1"
          />
        </g>
        <g>
          <path
            stroke="none"
            d="M20,10v18H2V10H20 M20.5,8h-19C0.7,8,0,8.7,0,9.5v19C0,29.3,0.7,30,1.5,30h19c0.8,0,1.5-0.7,1.5-1.5v-19C22,8.7,21.4,8,20.5,8L20.5,8z"
          />
        </g>
      </g>
    </svg>
  );
}

export default LockIcon;
